import { navigateTo, useQueryClient, USER_INFO_KEY } from '#imports'

/**
 * Where a browser request answered 401 goes. user/info is asked again rather than dropped: dropping
 * it flips isLoggedIn off and on, which refires every gated query, including the one that 401'd.
 * user/info's own 401 neither asks again nor navigates: its failed query already reads as logged out,
 * the auth middleware moves a logged-out visitor off player pages, and navigating from its response
 * would deadlock, as the user-status middleware waits on that same unfinished user/info request.
 */
export function redirectUnauthorized(lobbyPath: string, requestUrl?: string) {
    if (requestUrl?.includes('/user/info')) return

    return useQueryClient().refetchQueries({ key: USER_INFO_KEY, exact: true }).then<Awaited<ReturnType<typeof navigateTo>>>(() => {
        const { pathname, search } = window.location
        if (pathname === lobbyPath || pathname.startsWith(`${lobbyPath}/`)) return

        return navigateTo({ path: lobbyPath, query: { returnUrl: `${pathname}${search}` } })
    })
}
